import axios from "axios";
import store from "@/store";
import router from "@/router/index";

import { refreshToken } from "@/api/auth";

/*
    Title:
        API Calling Instance setting
    Auth:
        Token - django OAuth2Authentication
    Terms:
        AuthConnection: with Token
    Usage:
        AuthConnection.post(some-address, data)
        AuthConnection.get(some-address/1)
        AuthConnection.put(some-address/1, data)
        AuthConnection.delete(some-address/1)
*/

const baseURL = process.env.VUE_APP_API_ENDPOINT;
const tokenURL = process.env.VUE_APP_TOKEN_ENDPOINT;

const defaultTimeout = 30000;

export const AuthConnection = axios.create({
  baseURL: baseURL,
  timeout: defaultTimeout,
  headers: {
    Authorization: getToken(),
    "Content-Type": "application/json",
  },
});

export const Connection = axios.create({
  baseURL: baseURL,
  timeout: defaultTimeout,
  headers: {
    Authorization: null,
    "Content-Type": "application/json",
  },
});

export const tokenConnection = axios.create({
  baseURL: tokenURL,
  timeout: defaultTimeout,
  headers: {
    Authorization: getToken(),
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

const cognitoToken = axios.create({
  baseURL: process.env.VUE_APP_COGNITO_ENDPOINT,
  timeout: defaultTimeout,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
});

refreshOnTokenExpiredError(AuthConnection);

export function getAuthConnection() {
  if (!AuthConnection.defaults.headers["Authorization"]) {
    AuthConnection.defaults.headers["Authorization"] = getToken();
  }
  AuthConnection.defaults.headers["Content-Type"] = "application/json";
  AuthConnection.defaults.timeout = defaultTimeout;

  return AuthConnection;
}

export function getAuthConnectionWithNoTimeOut() {
  if (!AuthConnection.defaults.headers["Authorization"]) {
    AuthConnection.defaults.headers["Authorization"] = getToken();
  }
  AuthConnection.defaults.headers["Content-Type"] = "application/json";
  AuthConnection.defaults.timeout = null;
  return AuthConnection;
}

export function getFileAuthConnection() {
  let instance = getAuthConnection();
  instance.defaults.headers["Content-Type"] = "multipart/form-data";
  AuthConnection.defaults.timeout = null;
  return instance;
}

export function CognitoTokenConnection() {
  return cognitoToken;
}

export function getNoAuthConnection() {
  return Connection;
}

export function getToken() {
  // Get Cognito JWT for API calling.
  var Token = null;

  // Token이 setup 되지 않을 시.
  if (!store) return null;

  Token = store.getters.getToken;

  // Token이 잘못 지정되었을 때
  if (!Token) return null;

  return Token;
}

export function logout() {
  store.dispatch("signOut", { redirect: router.currentRoute.path });
}

function refreshOnTokenExpiredError(instance) {
  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const {
        config,
        response: { status },
      } = error;

      let user = store.getters.getUser;
      //console.log(user);
      if (status === 401) {
        let token = store.getters.getRefreshToken;
        if (!token) {
          // If there is no refresh token then sign out.
          console.log("There is no token, so signout.");
          logout();
        } else {
          // Refresh token and call failed request again.
          console.log("Token is expired, so refresh token.");
          const originalRequest = config;
          const res = await refreshToken(store.getters.getRefreshToken);
          store.commit("SET_TOKEN", res.data);

          instance.defaults.headers["Authorization"] = getToken();
          originalRequest.headers.Authorization = getToken();
          // 401로 요청 실패했던 요청 새로운 accessToken으로 재요청
          return axios(originalRequest);
        }
      } else if (!user || !user.groups || user.groups.length == 0) {
        // user 정보가 없거나, 미승인유저(그룹정보없음)인 경우 다시 login페이지로 보내 미승인 알람을 보여준다.
        console.log("User have no Permission");
        logout();
      }
      return Promise.reject(error);
    }
  );
}
